/**
 * Human-readable durations for SLA targets and timers.
 *
 * SLA targets are stored as integer MINUTES (business minutes). Showing a bare
 * "240" forces the reader to do mental arithmetic; market tools (Freshservice,
 * Zoho Desk, ServiceNow) render "4h". This is the single shared formatter so
 * every SLA surface speaks the same language.
 *
 * Pure presentation: it never changes a stored value, it only re-expresses an
 * already-computed minute count. Compact by design ("1h 30m", "2d 4h", "45m").
 */
/**
 * Format a minute count compactly: "45m", "1h", "1h 30m", "4h", "2d", "2d 4h".
 * `null`/`undefined`/negative → the em-dash placeholder used across the app.
 */
export function formatMinutes(mins) {
    if (mins == null || Number.isNaN(mins) || mins < 0)
        return '—';
    if (mins === 0)
        return '0m';
    const m = Math.round(mins);
    const days = Math.floor(m / 1440);
    const hours = Math.floor((m % 1440) / 60);
    const minutes = m % 60;
    const parts = [];
    if (days)
        parts.push(`${days}d`);
    if (hours)
        parts.push(`${hours}h`);
    if (minutes)
        parts.push(`${minutes}m`);
    return parts.join(' ');
}
